import {MathUtils,Vector3} from 'three';

/** Reversible anticipation, never a landing lock or an extra source of lift. */
export class GlideApproach {
  amount=0;
  update(dt:number,height:number,rise:number,speed:number,enabled:boolean):number {
    const reach=MathUtils.clamp(2.8+Math.max(0,-rise)*.48,3.2,7);
    const proximity=1-MathUtils.smoothstep(height,.35,reach);
    const descending=1-MathUtils.smoothstep(rise,-.8,.7);
    // At speed retain a shallow, trailing crouch instead of abruptly planting
    // both feet. Slowing down progressively permits the full landing posture.
    const deployment=1-.55*MathUtils.smoothstep(speed,24,50);
    const target=enabled&&Number.isFinite(height)?proximity*descending*deployment:0;
    this.amount+=(target-this.amount)*(1-Math.exp(-(target>this.amount?5.5:12)*Math.max(0,dt)));
    return this.amount;
  }
  brake(velocity:Vector3,up:Vector3,dt:number):void {
    const rise=velocity.dot(up),speed=Math.sqrt(Math.max(0,velocity.lengthSq()-rise*rise));
    // Bounded drag preserves heading and momentum through a fast ground skim.
    const drag=Math.min(speed,5.5*this.amount*dt),k=speed>0?1-drag/speed:1;
    velocity.multiplyScalar(k).addScaledVector(up,rise*(1-k));
  }
}
